export const VerticalsEnum = {
  CreditCards: 'credit_cards',
  Insurance: 'insurance',
  Mortgages: 'mortgages',
  PersonalLoans: 'personal_loans',
  BusinessLoans: 'business_loans',
  Banking: 'banking',
  StudentLoans: 'student_loans',
  OnlineBroker: 'online_broker',
  FinancialAdvisors: 'financial_advisors',
};

export const ActionsEnum = {
  Compare: 'compare',
  Personalize: 'personalize',
};

export type VerticalOption = {
  value: string;
  label: string;
  icon?: JSX.Element;
  hasTwoDropdowns?: boolean;
  entityName?: string;
};

export type ActionOption = {
  value: string;
  label: string;
};
